<template>
  <div class="content invite">
    <div class="message">
      <slot />
    </div>
    <div class="buttons btn-pair">
      <a v-if="isOpenedWithinElectronShell" href="#" @click="openExternal(meetingEmailString)">Send email</a>
      <a v-else :href="meetingEmailString" target="_blank" rel="noopener">Send email</a>
      <button ref="copyBtn" type="button" @click="meetingInviteLinkCloned()">
        <span class="text">Copy link</span>
        <transition name="basic">
          <span v-if="successMsg" class="copied">Copied!</span>
        </transition>
      </button>
    </div>
  </div>
</template>
<script setup>
import _ from 'underscore';
import { ref, computed, getCurrentInstance } from 'vue';
import { storeToRefs } from 'pinia';
import utils from '../resources/utils';
import emailString from '@/resources/emails';
import { useMeetingStore } from '@/store/pinia/meeting';
import { useAccountStore } from '@/store/pinia/account';

const accountStore = useAccountStore();
const meetingStore = useMeetingStore();
const isOpenedWithinElectronShell = utils.isOpenedWithinElectronShell();
const $API = getCurrentInstance().appContext.config.globalProperties.$API;

const { meetingUrl, personalRoomUrl, meetingId, isScheduled, isRoom, emailInfo } = storeToRefs(meetingStore);
const { baseUrl } = storeToRefs(accountStore);

const successMsg = ref(false);
const copyBtn = ref(null);

const meetingEmailString = computed(() => {
  let text;
  if (isScheduled.value) {
    text = emailString('scheduled', { ...emailInfo.value, baseUrl: baseUrl.value });
  } else if (isRoom.value) {
    text = emailString('roomStarted', { ...emailInfo.value, baseUrl: baseUrl.value, inviteLink: personalRoomUrl.value });
  } else {
    text = emailString('quickstart', { ...emailInfo.value, baseUrl: baseUrl.value });
  }
  return text;
});

async function meetingInviteLinkCloned() {
  const inviteLink = isRoom.value ? personalRoomUrl.value : meetingUrl.value;
  utils.clipBoard.addItem(inviteLink);
  copySuccess();
  await $API.insertMeetingStats(meetingId.value, { action: 'menu_copy_invite_used', source: 'meetingSidebar' });
}

function openExternal(url) {
  ipcApi.send({ name: 'openExternal', url: url, closeSelf: false });
}

function copySuccess() {
  successMsg.value = true;
  copyBtn.value.blur();
  _.delay(() => {
    successMsg.value = false;
  }, 3000);
}
</script>
<style lang="scss" scoped>
.copied {
  position: absolute;
  background: var(--c__success);
  color: var(--c__bg);
  line-height: rem(33px);
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
}

.message {
  @include type-size('medium');
  font-weight: bold;
  margin-bottom: rem(32px);
}

.buttons {
  height: rem(50px);
  border-width: 2px;
  --c__button: var(--c__text-loud);
  a,
  button,
  .copied {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  button {
    @include triggered {
      .text {
        text-decoration: none;
        color: var(--c__bg);
      }
    }
  }
  .text {
    margin: 0;
  }
}
</style>
